import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PdaPagamento } from '../models/pda-pagamenti';
import { PdaListaPagamentiRequest } from '../models/pda-lista-pagamenti-request';
import { PdaAvviso } from '../models/pda-avviso';
import { PdaRicevuta } from '../models/pda-ricevuta';
import { PdaGeneraAvvisoRequest } from '../models/pda-genera-avviso-request';
import { PdaDownloadAvvisoRequest } from '../models/pda-download-avviso-request';
import { PdaDownloadRicevutaRequest } from '../models/pda-download-ricevuta-request';

@Injectable({
  providedIn: 'root'
})
export class GestionePagamentiService {


  constructor(private http: HttpClient) { }

  generaAvviso(req: PdaGeneraAvvisoRequest): Observable<PdaAvviso>{
    return this.http.post<PdaAvviso>(ServicePathsSettings.URL_PDA_GENERA_AVVISO,req);
  }

  getListaPagamenti(req: PdaListaPagamentiRequest): Observable<PdaPagamento[]>{
    return this.http.post<PdaPagamento[]>(ServicePathsSettings.URL_PDA_LISTA_PAGAMENTI,req);
  }

  downloadAvviso(req: PdaDownloadAvvisoRequest): Observable<HttpResponse<any>>{
    return this.http.post(ServicePathsSettings.URL_PDA_DOWNLOAD_AVVISO,
      req,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    )
    .pipe(this.download_operator);
  }

  downloadRicevuta(req: PdaDownloadRicevutaRequest): Observable<HttpResponse<any>>{
    return this.http.post(ServicePathsSettings.URL_PDA_DOWNLOAD_RICEVUTA,
      req,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    )
    .pipe(this.download_operator);
  }

  download_operator(
    source$: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return source$.pipe(
      tap((res: HttpResponse<any>) => {
        const filename = res.headers
          .get('content-disposition')
          .split('filename=')[1];
        const blob = new Blob([res.body], {
          type: 'application/octet-stream',
        });
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        window.document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      })
    );
  }
}
